<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import '@/scss/base.scss'

export default {
  computed: {
    ...mapState({
      loading: state => state.loading,
    }),
  },
  methods: {
    ...mapActions({
      initDatas: 'star/initDatas',
      getUserInfo: 'user/getUserInfo',
    }),
  },
}
</script>
